export const CSS = {
  itemWrapper: "item-wrapper",
};
